<template>
  <div>
    <b-modal
      ref="gift-card-message-modal"
      hide-footer
      no-close-on-backdrop
      modal-backdrop
      hide-header
      id="gift-card-message-modal"
      centered
    >
      <div class="text-center" style="font-family: 'Open Sans'">
        <!-- Success Icon -->
        <div class="mt-3">
          <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="#179346" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22,4 12,14.01 9,11.01"></polyline>
          </svg>
        </div>
        
        <!-- Message Text -->
        <p class="mt-3 message-text">{{ messageText }}</p>
        
        <!-- OK Button -->
        <div class="mt-4">
          <button class="ok-button" @click="closeModal">
            OK
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "GiftCardMessageModal",
  props: {
    messageText: {
      type: String,
      default: ""
    }
  },
  data() {
    return {}
  },
  methods: {
    showMessageModal() {
      console.log('🎯 GiftCardMessageModal.showMessageModal called');
      console.log('🎯 Message text:', this.messageText);
      console.log('🎯 Modal ref exists:', !!this.$refs['gift-card-message-modal']);

      // Try multiple approaches to show the modal
      if (this.$refs['gift-card-message-modal']) {
        console.log('📢 Calling modal.show()...');
        this.$refs['gift-card-message-modal'].show();

        // Check if modal is visible after show
        this.$nextTick(() => {
          const modalElement = document.getElementById('gift-card-message-modal');
          console.log('🔍 Modal element:', modalElement);
          console.log('👁️ Modal display:', modalElement ? modalElement.style.display : 'not found');

          // Force display style if modal exists but is hidden
          if (modalElement) {
            console.log('🔧 Forcing modal display...');
            modalElement.style.display = 'block';
            modalElement.style.zIndex = '1050';
            modalElement.style.position = 'fixed';
            modalElement.style.top = '0';
            modalElement.style.left = '0';
            modalElement.style.width = '100%';
            modalElement.style.height = '100%';

            // Also ensure backdrop is visible
            const backdrop = document.querySelector('.modal-backdrop');
            if (backdrop) {
              backdrop.style.display = 'block';
              backdrop.style.opacity = '0.5';
              backdrop.style.zIndex = '1040';
            }

            // Check modal dialog positioning
            const modalDialog = modalElement.querySelector('.modal-dialog');
            if (modalDialog) {
              console.log('🔍 Modal dialog found, checking position...');
              modalDialog.style.margin = '1.75rem auto';
              modalDialog.style.position = 'relative';
              modalDialog.style.width = 'auto';
              modalDialog.style.maxWidth = '500px';
            }

            // Double-check after forcing
            setTimeout(() => {
              console.log('✅ Final modal display:', modalElement.style.display);
              if (modalElement.style.display !== 'block') {
                console.log('🔄 Still hidden, trying $bvModal...');
                if (this.$bvModal) {
                  this.$bvModal.show('gift-card-message-modal');
                }
              }
            }, 100);
          } else {
            console.log('🔄 Modal element not found, trying $bvModal...');
            if (this.$bvModal) {
              this.$bvModal.show('gift-card-message-modal');
            }
          }
        });
      } else {
        console.error('❌ Modal ref not found in showMessageModal!');

        // Try using $bvModal as fallback
        if (this.$bvModal) {
          console.log('🔄 Trying $bvModal fallback...');
          this.$bvModal.show('gift-card-message-modal');
        }
      }
    },
    closeModal() {
      console.log('🔒 Closing modal...');
      if (this.$refs['gift-card-message-modal']) {
        this.$refs['gift-card-message-modal'].hide();
      } else if (this.$bvModal) {
        this.$bvModal.hide('gift-card-message-modal');
      }
    }
  }
}
</script>

<style scoped>
/* Modal styling similar to crew modals */
#gift-card-message-modal___BV_modal_body_ {
  background-color: #ffffff;
  border-radius: 12px;
  margin: 10px;
}

#gift-card-message-modal___BV_modal_content_ {
  background-color: #ffffff;
}

/* Ensure modal is visible and properly layered */
#gift-card-message-modal {
  z-index: 1050 !important;
}

.modal-backdrop {
  z-index: 1040 !important;
}

/* Force modal visibility - more specific selectors */
#gift-card-message-modal.modal.show {
  display: block !important;
}

#gift-card-message-modal.modal.fade.show {
  display: block !important;
}

/* Override any conflicting styles */
div#gift-card-message-modal.modal {
  display: block !important;
}

/* Ensure backdrop is visible */
.modal-backdrop.show {
  opacity: 0.5 !important;
}

.message-text {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
  font-family: 'Open Sans', sans-serif;
  line-height: 1.4;
  margin: 20px 0;
}

.ok-button {
  background-color: #179346;
  color: white;
  border: none;
  padding: 12px 30px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
  font-family: 'Open Sans', sans-serif;
  min-width: 100px;
}

.ok-button:hover {
  background-color: #0f6b32;
}

.ok-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(23, 147, 70, 0.3);
}

/* Mobile responsive */
@media (max-width: 768px) {
  .message-text {
    font-size: 14px;
    margin: 15px 0;
  }
  
  .ok-button {
    padding: 10px 25px;
    font-size: 14px;
  }
}
#gift-card-message-modal___BV_modal_body_{
  background-color: #ffffff;
  border-radius: 12px;
  margin: 10px;
}
#gift-card-message-modal___BV_modal_content_{
    background-color: #ffffff;
}
</style>
